import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import axios from "axios";
import React from "react";
import { useSelector } from "react-redux";
import { UPLOADEXCEL_URL } from "../service/data";
const FileUploader = (props) => {
  const { accessToken } = useSelector((state) => state.user);
  const [dragActive, setDragActive] = React.useState(false);
  const [file, setFile] = React.useState("");
  const inputRef = React.useRef(null);
  const [uploadContent, setUploadContent] = React.useState({});
  const [buttonText, setButtonText] = React.useState("Upload Excel");
  const [buttonIcon, setButtonIcon] = React.useState(<UploadFileIcon />);
  const [heading, setHeading] = React.useState(
    <Typography style={{ fontStyle: "italic" }}>
      Drag and drop Excel file here
    </Typography>
  );

  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      handleFile(e.dataTransfer.files[0]);
    }
  };

  const handleChange = function (e) {
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
    }
  };

  const handleFile = function (file) {
    const url = UPLOADEXCEL_URL;
    const formData = new FormData();
    formData.append("file", file);
    setFile(file.name);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
        "x-api-key": process.env.REACT_APP_API_KEY,
        // Authorization: accessToken ? `Bearer ${accessToken}` : "",
      },
    };
    axios
      .post(url, formData, config)
      .then((response) => {
        const data = response.data;
        if (data.is_valid) {
          setUploadContent(data.upload_content);
          setButtonIcon(<CheckIcon />);
          setButtonText(file.name);
          setHeading(
            <Typography style={{ fontStyle: "italic" }}>
              File uploaded successfully.
            </Typography>
          );
          props.childData(data.upload_content);
        } else {
          setButtonText(file.name);
          setHeading(
            <Typography style={{ fontStyle: "italic", color: "#DC3545" }}>
              Error : Please fill all required very high important fields.
            </Typography>
          );
          setButtonIcon(<CloseIcon style={{ color: "#DC3545" }} />);
          props.childData({});
        }
      })
      .catch((error) => {
        console.log(error);
        setHeading(
          <Typography style={{ fontStyle: "italic", color: "#DC3545" }}>
            Error while uploading file
          </Typography>
        );
        setButtonText(file.name);
        setButtonIcon(<CloseIcon style={{ color: "#DC3545" }} />);
      });
  };
  const onButtonClick = () => {
    inputRef.current.click();
  };

  return (
    <form
      id="form-file-upload"
      onDragEnter={handleDrag}
      onSubmit={(e) => e.preventDefault()}
    >
      <input
        ref={inputRef}
        type="file"
        id="input-file-upload"
        onChange={handleChange}
      />
      <label
        id="label-file-upload"
        htmlFor="input-file-upload"
        className={dragActive ? "drag-active" : ""}
      >
        <div>
          {heading}
          <Button
            variant="contained"
            color="success"
            style={{
              backgroundColor: "#A6E0E5",
              color: "#000",
              textTransform: "capitalize",
            }}
            sx={{ mt: 3, mb: 2 }}
            onClick={onButtonClick}
          >
            {buttonIcon}
            {buttonText}
          </Button>
        </div>
      </label>
      {dragActive && (
        <div
          id="drag-file-element"
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        ></div>
      )}
    </form>
  );
};

export default FileUploader;
